<app-ets-component-router [embedName]="embedName">
    <app-ets-detail [embedName]="embedName" [identifier]="identifier" [showTitle]="showTitle" [showHeadliner]="showHeadliner" [showInfoAccordion]="showInfoAccordion" [showTicketing]="showTicketing"></app-ets-detail>
</app-ets-component-router>
